import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const loom = defineConnector({
  identifier: "loom",
  name: "Loom",
  tagLine: "Video messaging for work",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://www\\.loom\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Loom API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Loom Developer Portal](https://www.loom.com/developer-portal) and create an API key for your workspace.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API Key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.loom.com/v1/me",
  },
});
